import { type FC } from "react";

import { ProfileCircleIcon } from "@snapchat/snap-design-system-icons";

import ageSvg from "@app-assets/svg/age.svg";
import femaleSvg from "@app-assets/svg/female.svg";
import maleSvg from "@app-assets/svg/male.svg";

import { Flexbox } from "../../shared/components";

import { Card } from "./Card";
import { AverageAge, Female, Male, PotentialAudience } from "./messages.generated";
import { cardData, demographicFlex, iconStyle, row } from "./shared";

interface DemographicsData {
    potentialAudience: readonly [number, number];
    maleAudience: number;
    femaleAudience: number;
    averageAge: number;
}
interface CommunityAudienceDemographicsProps {
    demographicsData: DemographicsData | null;
    loading: boolean;
}

export const CommunityAudienceDemographics: FC<CommunityAudienceDemographicsProps> = ({
    demographicsData,
    loading,
}) => {
    return (
        <Flexbox className={row} alignItems="normal">
            <Card
                className={demographicFlex}
                icon={<ProfileCircleIcon size={24} />}
                loading={loading}
                content={
                    demographicsData && (
                        <div>
                            <div>
                                <PotentialAudience />
                            </div>
                            <div className={cardData}>
                                {`
                                            ${
                                                demographicsData.potentialAudience[0] < 1_000_000
                                                    ? `${Math.floor(demographicsData.potentialAudience[0] / 1000)}K`
                                                    : `${Math.floor(
                                                          demographicsData.potentialAudience[0] / 1_000_000,
                                                      )}M`
                                            }
                                            -
                                            ${
                                                demographicsData.potentialAudience[1] < 1_000_000
                                                    ? `${Math.floor(demographicsData.potentialAudience[1] / 1000)}K`
                                                    : `${Math.floor(
                                                          demographicsData.potentialAudience[1] / 1_000_000,
                                                      )}M`
                                            }
                                        `}
                            </div>
                        </div>
                    )
                }
            />
            <Card
                className={demographicFlex}
                icon={<img alt={"male icon"} src={maleSvg} style={iconStyle} />}
                loading={loading}
                content={
                    demographicsData && (
                        <div>
                            <div>
                                <Male />
                            </div>
                            <div className={cardData}>{`${demographicsData.maleAudience}%`}</div>
                        </div>
                    )
                }
            />
            <Card
                className={demographicFlex}
                icon={<img alt={"female icon"} src={femaleSvg} style={iconStyle} />}
                loading={loading}
                content={
                    demographicsData && (
                        <div>
                            <div>
                                <Female />
                            </div>
                            <div className={cardData}>{`${demographicsData.femaleAudience}%`}</div>
                        </div>
                    )
                }
            />
            <Card
                className={demographicFlex}
                icon={<img alt={"birthday icon"} src={ageSvg} style={iconStyle} />}
                loading={loading}
                content={
                    demographicsData && (
                        <div>
                            <div>
                                <AverageAge />
                            </div>
                            <div className={cardData}>{demographicsData.averageAge.toFixed(0)}</div>
                        </div>
                    )
                }
            />
        </Flexbox>
    );
};
